import { styled } from '../../../../../styled-system/jsx';
import { cva } from '../../../../../styled-system/css';

const h2 = cva({
  base: {
    color: 'headerText',
    fontSize: 'h2',
    fontWeight: 'bold',
  },
});

export const H2 = styled('h2', h2);
